// =====================================================================
// Viewport tier helpers — single source of truth
// ---------------------------------------------------------------------
// Boundaries align with the customised Bootstrap grid defined in
// `wwwroot/css/_adtraction-variables.scss`:
//
//   $at-grid-breakpoints-md: 768px   → tablet starts here
//   $at-grid-breakpoints-lg: 1024px  → desktop starts here
//
// Keep `TABLET_MAX` in sync with `$at-grid-breakpoints-lg - 1`. Using
// the default Bootstrap value (991) here would mis-classify the
// 992–1023px range as "desktop" while the CSS is still serving the
// tablet (md) layout.
//
// `MOBILE_PORTRAIT_MAX` is a JS-only finer split inside the mobile
// range used by animations that need to distinguish phone-portrait
// from phone-landscape; it does not correspond to a Bootstrap
// breakpoint.
// =====================================================================

export const VIEWPORT_BREAKPOINTS = {
  MOBILE_PORTRAIT_MAX: 479,
  MOBILE_LANDSCAPE_MAX: 767,
  TABLET_MAX: 1023,
};

export function getCurrentViewportTier() {
  const width = window.innerWidth;
  if (width <= VIEWPORT_BREAKPOINTS.MOBILE_PORTRAIT_MAX)
    return "mobile-portrait";
  if (width <= VIEWPORT_BREAKPOINTS.MOBILE_LANDSCAPE_MAX)
    return "mobile-landscape";
  if (width <= VIEWPORT_BREAKPOINTS.TABLET_MAX) return "tablet";
  return "desktop";
}

export function isMobileTier(tier) {
  return tier === "mobile-portrait" || tier === "mobile-landscape";
}

export function isTabletTier(tier) {
  return tier === "tablet";
}

export function isDesktopTier(tier) {
  return tier === "desktop";
}

// Convenience predicate for blocks where everything below the
// desktop breakpoint (i.e. width < 1024px) should share the same
// "compact" behaviour. Use this when the tablet layout cannot host
// the desktop animation/layout (e.g. horizontal scrubs that need
// wide containers).
export function isMobileOrTabletTier(tier) {
  return isMobileTier(tier) || isTabletTier(tier);
}
